define('pages/user-settings',["require", "exports", "../dom", "../util/http", "../views/text-setting"], function (require, exports, dom_1, http_1, text_setting_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(userId) {
        // Edit name
        var nameSetting = (0, dom_1.q)(".user-name")[0];
        if (nameSetting) {
            new text_setting_1.TextSetting({
                element: nameSetting,
                selectMode: text_setting_1.TextSettingMode.SelectEnd,
                closeOnBlur: true,
                save: function (name) {
                    return (0, http_1.postJson)("/users/" + userId + "/name", name)
                        .catch(function (e) { throw new Error("Failed to save user name: " + e); });
                }
            });
        }
        // Edit weight
        var weightSetting = (0, dom_1.q)(".user-weight")[0];
        if (weightSetting) {
            new text_setting_1.TextSetting({
                element: weightSetting,
                selectMode: text_setting_1.TextSettingMode.SelectEnd,
                closeOnBlur: true,
                save: function (weightString) {
                    var weight = Number(weightString);
                    if (!isNaN(weight) && weight > 10 && weight < 300) {
                        return (0, http_1.postJson)("/users/" + userId + "/weight", weight)
                            .catch(function (e) { throw new Error("Failed to save user weight: " + e); });
                    }
                    else {
                        return Promise.reject(new Error("invalid weight"));
                    }
                }
            });
        }
        // TODO: Edit units
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/pages/user-settings.js.map;
